import { AYAdSlot } from '@/components/frontend/AYAdSlot'

interface Props {
    adCount: number
    adWidth?: number
    adHeight?: number
}

export const SidebarAds: React.FC<Props> = ({ adCount, adWidth = 336, adHeight = 280 }: Props) => {
    return (
        <div className='hidden md:flex flex-col'>
            {Array.from(Array(adCount)).map((_el, i) => {
                const paddingTop = i === 0 ? 0 : 8
                const borderBottom = i % 2 === 1 && i !== adCount - 1 ? 'border-b' : ''
                return (
                    <div key={i} className={`md:block pb-8 pt-${paddingTop} ${borderBottom}`}>
                        <AYAdSlot adId={`qz.com_${adWidth}x${adHeight}`} width={adWidth} height={adHeight} />
                    </div>
                )
            })}
        </div>
    )
}
